import React from 'react';

import { flagStyles } from '../settings';

const SvgSV = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-4992px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgSV;
